import { useMemo } from "react";
import { InformationType, StageTypes } from "../enums/index";

export const useActVideo = (result) => {
  const actVideo = useMemo(() => {
    const is40YardDash =
      result?.physicalTestName === InformationType["40YardDash"];
    const isStage20 = Number(result?.stage) === Number(StageTypes[20]);
    if (is40YardDash && isStage20) return false;
    return true;
  }, [result]);

  return actVideo;
};
